// TSK-5314 (GPR): an Advance order completed on an online till (disableOfflineBilling "Y") keeps
// its ADV/ number on s_order; the backend's async LayAwayOrderProcessor mints the till invoice
// number (GDPPOS/...) on s_invoice, and confirmPOSLayawayOrder1 only echoes the ADV number back.
// The receipt shows the invoice number through a print template placeholder
// (@@printReciptDataInvoiceNo@@, or {{receiptInvoiceNo}} on the CW hardware controller template). Print
// only: the saved order, the counter and the sync payload keep the ADV number, and a template
// that does not use the placeholder prints exactly as before.

const INVOICE_NO_ATTEMPTS = 6;
const INVOICE_NO_INTERVAL_MS = 1000;

const cleanInvoiceNo = (value) => (typeof value === "string" ? value.trim() : "");

// Value of the invoice number placeholder: the server's invoice number when the receipt carries
// one (Sales History rows, the completion print after fetchAdvanceInvoiceNo), else the receipt's
// own number -- a regular sale's documentno already is its invoice number.
export const getReceiptInvoiceNo = (receipt) => cleanInvoiceNo(receipt?.invoiceNo) || receipt?.documentno || "";

// TSK-5857: the invoice number only when the receipt has one of its own, different from its order
// number (advance completion and its reprint). Create Advance, an uncompleted advance's reprint and a
// regular sale (invoice number = order number) -> "".
export const getDistinctInvoiceNo = (receipt) => {
  const invoiceNo = cleanInvoiceNo(receipt?.invoiceNo);
  return invoiceNo && invoiceNo !== receipt?.documentno ? invoiceNo : "";
};

// Complete Sale of an Advance on an online till: still numbered on the ADV series. Create Advance
// and top-ups set statusType "layAway" and are left alone.
export const isOnlineAdvanceCompletion = (order, posConfig, preorderPrefix) =>
  posConfig?.disableOfflineBilling === "Y" &&
  order?.layAway === "Y" &&
  order?.statusType !== "layAway" &&
  order?.isReturn !== "Y" &&
  order?.isReturn !== true &&
  !!order?.sOrderID &&
  !!preorderPrefix &&
  typeof order?.documentno === "string" &&
  order.documentno.startsWith(preorderPrefix);

const defaultWait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

// The invoice is written after confirmPOSLayawayOrder1 answers, so ask Sales History a few times.
// Returns null when it is not there in time; the caller then prints the ADV number as before.
// fetcher is services' salesHistoryDetails (passed in: the printers import this file).
export const fetchAdvanceInvoiceNo = async (sOrderID, fetcher, { attempts = INVOICE_NO_ATTEMPTS, intervalMs = INVOICE_NO_INTERVAL_MS, wait = defaultWait } = {}) => {
  if (typeof fetcher !== "function" || typeof sOrderID !== "string" || !/^[A-Za-z0-9-]+$/.test(sOrderID)) return null;
  const query = { query: `query { salesHistoryDetails(orderId: "${sOrderID}") { sOrderID documentno invoiceNo } }` };
  for (let attempt = 0; attempt < attempts; attempt += 1) {
    if (attempt > 0) await wait(intervalMs);
    const response = await fetcher(query);
    const invoiceNo = cleanInvoiceNo(response?.data?.data?.salesHistoryDetails?.[0]?.invoiceNo);
    if (invoiceNo) return invoiceNo;
  }
  return null;
};
